var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.scroll,
          expression: "scroll"
        }
      ],
      staticClass: "login"
    },
    [
      _vm.lang === "en"
        ? _c("cookie", {
            staticStyle: { "z-index": "2", position: "relative" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.requireLogin
        ? _c("div", { staticClass: "login-wrapper" }, [
            !_vm.loggedIn
              ? _c("div", { staticClass: "login-main" }, [
                  _c("img", {
                    staticClass: "czur-logo",
                    attrs: {
                      src: require("../assets/images/czur_logo.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("index.loginText")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userName,
                          expression: "userName"
                        }
                      ],
                      staticClass: "input-account",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("index.accountNumber")
                      },
                      domProps: { value: _vm.userName },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.login($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.userName = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "input-pwd",
                      attrs: {
                        type: "password",
                        placeholder: _vm.$t("index.password")
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          },
                          _vm.inputOnchange
                        ],
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.login($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "icon-login-btn",
                      on: { click: _vm.login }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "login-loading",
                        class: { show: _vm.logining }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "container" },
                          [_c("loading", { attrs: { loading: true } })],
                          1
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "verifyMsg",
                      class: { show: _vm.verifyMsg }
                    },
                    [_vm._v(_vm._s(_vm.$t("index.errorTip")))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "btns-line" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btns register-btn",
                        on: { click: _vm.register }
                      },
                      [_vm._v(_vm._s(_vm.$t("index.register")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btns",
                        on: {
                          click: function($event) {
                            _vm.showPop = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("index.forgetPwd")))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "line" }),
                  _vm._v(" "),
                  _vm.thirdLogin
                    ? _c("div", { staticClass: "third-party" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101562028&scope=get_user_info&redirect_uri=https%3a%2f%2fpassport.czur.cc%2fapi%2fv2%2fpublic%2fthirdOAuth%2fcallback%3fadaptor%3dqq_web%26lang%3d" +
                                _vm.lang +
                                "%26callback%3d" +
                                _vm.pageHref +
                                "&state=" +
                                _vm.timeStamp,
                              id: "qqBtn"
                            }
                          },
                          [_c("i", { staticClass: "icon-qq" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://open.weixin.qq.com/connect/qrconnect?appid=wx1d6ec286ebe96e95&redirect_uri=https%3a%2f%2fpassport.czur.cc%2fapi%2fv2%2fpublic%2fthirdOAuth%2fcallback%3fadaptor%3dwechat_web%26lang%3d" +
                                _vm.lang +
                                "%26callback%3d" +
                                _vm.pageHref +
                                "&response_type=code&scope=snsapi_login&state=" +
                                _vm.timeStamp +
                                "#wechat_redirect",
                              id: "weiinBtn"
                            }
                          },
                          [_c("i", { staticClass: "icon-weixin" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://api.weibo.com/oauth2/authorize?client_id=1207713704&response_type=code&redirect_uri=https%3A%2F%2Fpassport.czur.cc%2Fapi%2Fv2%2Fpublic%2FthirdOAuth%2Fcallback%3fadaptor%3dweibo_web%26lang%3d" +
                                _vm.lang +
                                "%26callback%3d" +
                                _vm.pageHref,
                              id: "weiboBtn"
                            }
                          },
                          [_c("i", { staticClass: "icon-weibo" })]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-footer" }, [
                    _c(
                      "span",
                      {
                        staticClass: "lang",
                        on: {
                          click: function($event) {
                            return _vm.changeLocale("zh-CN")
                          }
                        }
                      },
                      [_vm._v("简体中文")]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "lang",
                        on: {
                          click: function($event) {
                            return _vm.changeLocale("en")
                          }
                        }
                      },
                      [_vm._v("English")]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "lang",
                        on: {
                          click: function($event) {
                            return _vm.changeLocale("zh-TW")
                          }
                        }
                      },
                      [_vm._v("繁體中文")]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "lang",
                        on: {
                          click: function($event) {
                            return _vm.changeLocale("ru_RU")
                          }
                        }
                      },
                      [_vm._v("Pусский")]
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.loggedIn
              ? _c(
                  "div",
                  {
                    staticClass: "select-function",
                    class: { animate: _vm.loggedIn }
                  },
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("index.selectFunction")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "select-bottom" }, [
                      _c("div", { staticClass: "select-item-wrap clearfix" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select-item select-item-et",
                            on: { click: _vm.goEt }
                          },
                          [
                            _c("img", {
                              staticClass: "select-item-img",
                              attrs: {
                                src: require("../assets/images/select_et.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "select-item-title" }, [
                              _vm._v("ET")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "select-item select-item-notebook",
                            on: { click: _vm.goNotebook }
                          },
                          [
                            _c("img", {
                              staticClass: "select-item-img",
                              attrs: {
                                src: require("../assets/images/select_notebook.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "select-item-title" }, [
                              _vm._v(_vm._s(_vm.$t("index.notebook")))
                            ])
                          ]
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "login-mark" }),
            _vm._v(" "),
            _c("i", { staticClass: "icon-czur-logo" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showPop
        ? _c("div", { staticClass: "pop" }, [
            _c("div", { staticClass: "pop-box main clearfix" }, [
              _c("div", { staticClass: "pop-main" }, [
                _c("div", { staticClass: "pop-main-top" }, [
                  _vm._v(_vm._s(_vm.$t("findPwd.account_type")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pop-btn-box" }, [
                  _c(
                    "div",
                    { staticClass: "pop-btn", on: { click: _vm.gofindPwd } },
                    [_vm._v(_vm._s(_vm.$t("findPwd.starryHub_account")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pop-btn", on: { click: _vm.findPwd } },
                    [_vm._v(_vm._s(_vm.$t("findPwd.czur_cloud_account")))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "icon-close",
                on: {
                  click: function($event) {
                    _vm.showPop = false
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showCountryInternal
        ? _c("div", { staticClass: "pop-country-code" }, [
            _c("div", { staticClass: "pop-box main clearfix" }, [
              _c("div", { staticClass: "pop-main" }, [
                _c("div", { staticClass: "pop-main-top" }, [
                  _vm._v(_vm._s(_vm.$t("operation.msg")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "pop-content-box" }, [
                  _c("div", { staticClass: "pop-text" }, [
                    _vm._v(_vm._s(_vm.$t("index.countryError")))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pop-btn", on: { click: _vm.goCountryHost } },
                  [_vm._v(_vm._s(_vm.$t("index.countryGo")))]
                )
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "icon-close",
                on: {
                  click: function($event) {
                    _vm.showCountryInternal = false
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.logoutAPIs, function(api, index) {
        return _c("iframe", {
          key: index,
          staticClass: "logout-frame",
          attrs: { src: api, frameborder: "0" }
        })
      }),
      _vm._v(" "),
      _c("iframe", {
        staticClass: "login-check",
        attrs: { src: _vm.loginCheckUrl },
        on: { load: _vm.loginCheckLoaded }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy-right" }, [
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn", target: "_blank" } },
        [_vm._v("辽ICP备13011158号-8")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 